export const version = "providers/5.6.6";
//# sourceMappingURL=_version.js.map